import io from "socket.io-client"
const socket = io.connect(process.env.VUE_APP_WEBSOCKETS || "http://localhost:3000")

export default socket
